import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=aa3be856&scoped=true&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3be856",
  null
  
)

export default component.exports